import { useAuth } from '../hooks/useAuth'
import WelcomePage from './WelcomePage'
import CityPickerPage from './CityPickerPage'

/**
 * Root route component.
 *
 * - While auth is loading: render nothing (avoids flashing the wrong screen).
 * - Guest: show the welcome screen (WelcomePage).
 * - Authenticated: show the city/language picker (CityPickerPage).
 */
export default function StartPage() {
  const { user, isLoading } = useAuth()

  if (isLoading) return null

  return user ? <CityPickerPage /> : <WelcomePage />
}
